import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import Btn from '../../components/shared/button/Btn'
import darkLogo from "../../images/svg/colors/dark/kamyoon-dark.svg"
import lightLogo from "../../images/svg/colors/light/kamyoon-light.svg"
import { useDispatch } from 'react-redux'
import { showModal } from '../../features/modal/modalSlice'
import { getSavedEArsivCustomer } from '../../features/e-Arsiv/eArsivSlice'
import KayitliMusterilerContainer from '../../components/eArsivContainers/KayitliMusterilerContainer'
const Container = styled.div`
  width: 100%;
  height: 100%;
    .wrapper{
      width: 100%;
      padding: 30px;
      .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        .top-container{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
        }
        .titles {
          width: 100%;
          gap: 10px;
          margin-block: 20px;
          padding-inline: 10px;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          color: ${({ theme }) => theme.mainTextColor};
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          text-align: center;
        }
        
      }
    }

`

const EArsivKayitliMusteri = () => {
  const {theme} = useSelector((state) => state.layout)
    const dispatch = useDispatch()
    const titles = ["Müşteri Adı Soyadı", "Ünvan", "Vergi No / TC No", "Vergi Dairesi"]
    const {registeredCustomerList} = useSelector((state) => state.eArsiv)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const gibToken = JSON.parse(storage.getItem("gibToken"))


    useEffect(() => {
      dispatch(getSavedEArsivCustomer())
    }, [])


  return (
    <Container>
        <PageTopTitle title={"Kayıtlı Müşteriler"} position='sticky' top='210px'/>

        <div className="wrapper">
            <div className="content">

                <div className="top-container">
                    <Btn handleClick={() => {gibToken && dispatch(showModal("eArsivKayitliMusteriEkle"));}} bgColor='transparent' padding='10px' color='#E85446' width="150px" >Ekle</Btn>
                </div>

                <div className="titles">
                {titles.map((item) => (
                    <div className='title'>{item}</div>
                ))}
                </div>

                {registeredCustomerList?.map((item) => (
                  <KayitliMusterilerContainer data={item} />
                ))}
                
            </div>
        
        </div>
    </Container>
  )
}

export default EArsivKayitliMusteri